import crossDomainInitTemplateUrl from '../../../app/crossdomain/crossDomainInit.tpl.html';
import logger from '../../../common/logger';

const log = logger('CrossDomainInit');
const error = log.extend('error');

const CrossDomainInitController = [
    '$window',
    '$location',
    '$scope',
    'signalboost',
    'logService',
    function ($window, $location, $scope, signalboost, logService) {
        const $ctrl = this;

        function initError(e) {
            logService.logData('ERROR', 'crossDomainInit: error initiating cross-domain auth', e);
            error('Error initiating cross-domain auth', e);
            $location.path('/signin');
        }

        $scope.startCrossDomainInit = () => {
            const { targetOrgId, targetPath } = $location.search();
            if (!targetOrgId) {
                initError('Missing targetOrgId for cross-domain init');
                return;
            }

            signalboost.user
                .initCrossDomain({ targetOrgId, targetPath })
                .then((result) => {
                    if (result && result.redirectUrl) {
                        $window.location = result.redirectUrl;
                    } else {
                        initError('Missing redirectUrl from cross-domain init');
                    }
                })
                .catch(initError);
        };

        $ctrl.$onInit = () => {
            $scope.startCrossDomainInit();
        };
    },
];

// there is no ui for the cross-domain init
// it's just a redirect to the auth exchange URL
export default {
    templateUrl: crossDomainInitTemplateUrl,
    controller: CrossDomainInitController,
};
